export default (theme) => ({
  background: {
    background: theme.palette.background.default,
  },
});
